
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { AnModalSetting, BreakpointsEnum } from '../../models/an-modal-setting';
import { LocateMeData, VerifyConfigData } from '../../models/locate-me-rendering-response';
import { RoadsterParams } from '../../models/roadster-params';
import { GeolocationService } from '../../services/geolocation.service';
import { ProgressBarService } from '../../services/progress-bar.service';
import { StateService } from '../../services/state.service';
import { TealiumSubmitService } from '../../services/tealiumSubmitService/tealium-submit.service';
import { UtilsService } from '../../services/utils.service';
import { ZipcodeService } from '../../services/zipcode.service';
import { CONSTANTS } from './../../global';
declare const Swiper:any;

@Component({
  selector: 'lib-zip-slideout',
  templateUrl: './zip-slideout.component.html',
  styleUrls: ['./zip-slideout.component.scss']
})
export class ZipSlideoutComponent implements OnInit {

  errorMessages = new Map<string, string>();

  zipcodeForm: any;

  progressBarSetting = {
    borderRadius: '15px 15px 0 0'
  }

  modalOpen = false;
  modalSetting: AnModalSetting = {
    closing: {
      backdrop: true,
      esc: true
    }
  };

  roadsterParmas!: RoadsterParams;
  zipCodeContent : string = '';
  locateMeData!: LocateMeData;
  verifyConfigData!: VerifyConfigData;

  constructor(
    private readonly fb: FormBuilder,
    private readonly stateService: StateService,
    private readonly geolocationService: GeolocationService, 
    private tealiumSubmit: TealiumSubmitService,
    private readonly utils: UtilsService,
    private readonly loading: ProgressBarService,
    public zipcodeService: ZipcodeService,
  ) { }

  ngOnInit(): void {
    this.zipcodeForm = this.fb.group({
      zipcode: ['', [Validators.required, Validators.minLength(5)]]
    });     
    this.initState();

    this.tealiumSubmit.tealium.setConfig({
          account: 'autonation',
          profile: 'sitecorean',
          environment: 'dev'
    });

    document.addEventListener('open-verify-zipcode-modal-event', (event: any) => {
      console.log('Received roadster params...', event.detail);
      this.roadsterParmas = event.detail;
      if(event.detail.zipCodeHtml){
        this.zipCodeContent = event.detail.zipCodeHtml;
      }
      this.setZipcodeValue();
      this.open();
      this.sliderInit();
    });
  }

  initState() {
    this.stateService.renderingDataSubject.subscribe(renderingData => {
      if (this.utils.extractValueFromObject(renderingData, 'LocateMeData.Success')) {
        this.locateMeData = renderingData.LocateMeData;
        this.verifyConfigData = renderingData.VerifyConfigData;

        if (this.verifyConfigData) {
          this.errorMessages.set('required', this.verifyConfigData.ZipCodeRequired);
          this.errorMessages.set('minlength', this.verifyConfigData.ZipCodeRequired);
          this.errorMessages.set('invalidZipcode', this.verifyConfigData.InvalidZipCode);
        }
      }
    });
  }

  sliderInit (){
    //document.addEventListener("DOMContentLoaded", function(){
      setTimeout (function(){
        console.log("dom loaded")
        if(Swiper) {
          var swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 3,
            // init: false,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              375: {
                slidesPerView: 1,
                spaceBetween: 30,
              }
            },
          });
        }
      }, 1000)
      
    //});
    
  }

  open() {
    this.setZipcodeValue();
    this.modalOpen = true;
  }

  close() {
    this.modalOpen = false;
    this.loading.clear();
  }

  get zipcode(): AbstractControl | null {
    return this.zipcodeForm.get('zipcode');
  }

  get isInvalidZipcode(): boolean | undefined {
    return this.zipcode?.invalid && !this.zipcode.pristine;
  }

  updateZipcode() {    
    if (this.zipcodeForm.valid) {
      this.loading.start();      
      this.zipcodeService.updateZipcode(this.zipcode?.value).subscribe(response => {
        if (response.Success) {
          this.close();
          const updatedZipcode = response.ZipCodeData.PostalCode;

          this.stateService.renderingData.LocateMeData.PreferredZipCode = updatedZipcode;
          document.dispatchEvent(new CustomEvent(CONSTANTS.ROADSTER_ZIPCODE_CHANGED, { detail: updatedZipcode }));
          this.roadsterParmas.zip_code = updatedZipcode;          
          const roadster = (window as any).roadster;          
          console.log('roadster reference...', roadster);
          if (roadster) {  
            localStorage.setItem("IsRoadster", "true"); 
            document.cookie = "RefreshTransactionCookie=true";                   
            roadster.openSlideout(this.roadsterParmas);       
            this.tealiumSubmit.submitZipcodeModalTealium();     
          } 
        } else {
          localStorage.removeItem("IsRoadster");
          const error = response.ErrorCodes.find(error => error.Code.indexOf('ERRCODE') === 0);
          if (error && this.zipcode) {
            this.zipcode.setErrors({ invalidZipcode: true });
            console.log('Setting invalid zipcode error...');
          } else {
            // TODO: handle this error
            console.warn('Response fail', response);
          }
        }
        this.loading.clear();
      }, error => {
        console.log(error);
        this.loading.clear();
      });
    } else {
      this.zipcode?.markAsDirty();
    }
  }

  getZipcode() {
    this.loading.start();
    this.geolocationService.getZipcode().subscribe(value => {
      if (value) {
        this.zipcode?.setValue(value);
      } else {
        this.setZipcodeValue();
      }
      this.loading.clear();
    }, _ => {
      this.setZipcodeValue();
      this.loading.clear();
    });
  }

  setZipcodeValue(): void {
    this.zipcode?.setValue(this.roadsterParmas.zip_code
      || this.locateMeData.PreferredZipCode
      || this.locateMeData.DefaultZipCode);
  }

  get getErrorMessage(): string | undefined {
    const key = Object.keys(this.zipcode?.errors as any).pop();
    return key ? this.errorMessages.get(key) : '';
  }

  changeBreakpoint(breakpoint: BreakpointsEnum) {
    this.progressBarSetting = {
      borderRadius: breakpoint === BreakpointsEnum.sm ? '0' : '15px 15px 0 0'
    };
  }

  clearZipcode() {
    this.zipcode?.reset();
  }
}
